import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../css/PropertyCard.css';
import AnimatedButton from './AnimatedButton';

const PropertyCard = ({ property }) => (

    <motion.div
        className="property-card"
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.3 }}
    >
        <img src={property.image} alt={property.title} />
        <h3>{property.title}</h3>
        <p>{property.price}</p>
        <Link to={`/properties/${property.id}`}><span className='details-button'><AnimatedButton text="View Details" /></span></Link>

    </motion.div>
);

export default PropertyCard;